import React, { useEffect, useState } from "react";
import logo from "../assets/images/LOGO Support Useful links About Us Career Become An Instructor Become An Affiliate Lorem Ipsum is simply dummy text of the printing and typesetting industry 1 (2).png";
import { useDispatch, useSelector } from "react-redux";
import { getCartWishlistLength } from "../Redux/AllSlices/products";
import { useNavigate, Link } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";
import { CircleUser, Heart, ShoppingCart, Menu, X, MapPin } from "lucide-react";
import { getAllRootCategories } from "../Redux/AllSlices/categories";
import axios from "../appUtils/axiosConfig";
import HeaderSearchBar from "./common/HeaderSearchBar";
import DeliveryLocationModal from "./common/DeliveryLocationModal";

export default function SanjeevikaStore() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [headerHeading, setHeaderHeading] = useState("");
  const { rootcategorieslist } = useSelector((state) => state.categories);
  const { cartCount, wishlistCount } = useSelector((state) => state.products);
  const { isAuthenticated: loggedIn } = useSelector((state) => state.auth);

  const [deliveryLoc, setDeliveryLoc] = useState(() => {
    const saved = localStorage.getItem("delivery_location");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {}
    }
    const pin = localStorage.getItem("user_pincode");
    return pin ? { pincode: pin } : null;
  });

  useEffect(() => {
    const syncLocation = () => {
      const saved = localStorage.getItem("delivery_location");
      if (saved) {
        try {
          setDeliveryLoc(JSON.parse(saved));
          return;
        } catch (e) {}
      }
      const pin = localStorage.getItem("user_pincode");
      setDeliveryLoc(pin ? { pincode: pin } : null);
    };

    window.addEventListener("delivery_location_updated", syncLocation);
    window.addEventListener("storage", syncLocation);

    return () => {
      window.removeEventListener("delivery_location_updated", syncLocation);
      window.removeEventListener("storage", syncLocation);
    };
  }, []);

  const locationDisplay = deliveryLoc?.city
    ? `${deliveryLoc.city} ${deliveryLoc.pincode ? `(${deliveryLoc.pincode})` : ""}`
    : deliveryLoc?.pincode
    ? `PIN ${deliveryLoc.pincode}`
    : "Select Location";

  const finalCartCount = isAuthenticated() || loggedIn ? cartCount : 0;
  const finalWishlistCount = isAuthenticated() || loggedIn ? wishlistCount : 0;

  const handleNavigate = (url) => {
    navigate(`/${url}`);
    setIsMenuOpen(false);
  };

  const handleNavigateProfile = () => {
    navigate("/profile");
    setIsMenuOpen(false);
  };

  useEffect(() => {
    if (isAuthenticated()) dispatch(getCartWishlistLength());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllRootCategories());
  }, [dispatch]);

  // Close mobile menu on resize to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setIsMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchHeaderHeading = async () => {
      try {
        const res = await axios.get(`header/get_heading.php`);
        if (res?.data?.status === "success") {
          setHeaderHeading(res?.data?.data?.heading);
        }
      } catch (err) {
        // Silently handle offline/network error
      }
    };
    fetchHeaderHeading();
  }, [dispatch]);

  return (
    <>
      {/* Delivery Location Modal */}
      <DeliveryLocationModal
        isOpen={isLocationModalOpen}
        onClose={() => setIsLocationModalOpen(false)}
      />

      {/* Welcome Banner */}
      <div className="bg-[#77C712] text-white">
        <div className="py-1.5">
          <div className="overflow-hidden whitespace-nowrap w-full">
            <span className="marquee-tag text-sm font-medium animate-marquee inline-block">
  &nbsp;&nbsp;
  <span
    dangerouslySetInnerHTML={{
      __html:
        headerHeading ||
        "🌿 Welcome to Sanjeevika Store — Your Trusted Health & Wellness Destination",
    }}
  />
  &nbsp;&nbsp;
</span>
          </div>
        </div>
      </div>

      {/* Sticky Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-screen-xl mx-auto px-3 sm:px-4 lg:px-6">
          {/* ── Top Row ── */}
          <div className="flex items-center gap-2 sm:gap-4 py-2 sm:py-3 justify-between">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0">
              <img
                src={logo}
                alt="Sanjeevika Logo"
                className="h-10 sm:h-12 lg:h-14 w-auto object-contain"
                loading="eager"
                fetchpriority="high"
              />
            </Link>

            {/* Delivery Location Pill — Desktop/Tablet (sm+) */}
            <button
              type="button"
              onClick={() => setIsLocationModalOpen(true)}
              className="hidden sm:flex items-center gap-2 px-2.5 py-1.5 rounded-xl hover:bg-gray-50 transition-all border border-gray-200 text-left flex-shrink-0 shadow-sm group cursor-pointer"
              title="Click to change delivery PIN code"
            >
              <div className="w-7 h-7 rounded-lg bg-green-50 flex items-center justify-center text-[#77C712] group-hover:bg-[#77C712] group-hover:text-white transition-colors flex-shrink-0">
                <MapPin size={15} />
              </div>
              <div className="leading-tight">
                <span className="block text-[10px] text-gray-400 font-bold uppercase tracking-wider">
                  Deliver to
                </span>
                <span className="block text-xs font-extrabold text-gray-800 group-hover:text-[#77C712] transition-colors truncate max-w-[110px] md:max-w-[140px]">
                  {locationDisplay}
                </span>
              </div>
            </button>

            {/* Search Bar with Live Suggestions — Desktop & Tablet (md+) */}
            <div className="hidden md:flex flex-1 max-w-lg mx-2 lg:mx-4 relative z-40">
              <HeaderSearchBar isMobile={false} />
            </div>

            {/* Right-side Icons */}
            <div className="flex items-center gap-1 sm:gap-3">
              {/* Wishlist */}
              <button
                onClick={() => handleNavigate("wish-list")}
                className="relative flex items-center gap-1.5 text-gray-700 hover:text-[#77C712] transition-colors p-1.5"
                title="Wishlist"
              >
                <Heart size={20} />
                <span className="hidden lg:inline text-sm font-semibold">
                  Wishlist
                </span>
                {finalWishlistCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[9px] font-bold rounded-full min-w-[16px] h-4 flex items-center justify-center px-1 leading-none">
                    {finalWishlistCount}
                  </span>
                )}
              </button>

              {/* Cart */}
              <button
                onClick={() => handleNavigate("cart")}
                className="relative flex items-center gap-1.5 text-gray-700 hover:text-[#77C712] transition-colors p-1.5"
                title="Cart"
              >
                <ShoppingCart size={20} />
                <span className="hidden lg:inline text-sm font-semibold">
                  Cart
                </span>
                {finalCartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[9px] font-bold rounded-full min-w-[16px] h-4 flex items-center justify-center px-1 leading-none">
                    {finalCartCount}
                  </span>
                )}
              </button>

              {/* Login / Profile */}
              {!isAuthenticated() ? (
                <button
                  onClick={() => handleNavigate("login")}
                  className="hidden lg:block bg-[#77C712] hover:bg-green-600 text-white text-sm font-semibold px-3 py-2 rounded transition-colors whitespace-nowrap"
                >
                  Login
                </button>
              ) : (
                <button
                  onClick={handleNavigateProfile}
                  className="text-gray-700 hover:text-[#77C712] transition-colors p-1.5"
                  title="Profile"
                >
                  <CircleUser size={22} />
                </button>
              )}

              {/* Track Order — Desktop only */}
              <button
                onClick={() => handleNavigate("profile")}
                className="hidden lg:block bg-[#77C712] hover:bg-green-600 text-white text-sm font-semibold px-3 py-2 rounded transition-colors whitespace-nowrap"
              >
                Track Order
              </button>

              {/* Hamburger — Mobile/Tablet */}
              <button
                className="lg:hidden p-1.5 text-gray-700 hover:text-[#77C712] transition-colors"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* Delivery Location Bar — Mobile only */}
          <div className="sm:hidden pb-1.5">
            <button
              type="button"
              onClick={() => setIsLocationModalOpen(true)}
              className="w-full flex items-center justify-between px-3 py-1.5 rounded-lg bg-gray-50 border border-gray-200 text-xs font-semibold text-gray-800"
            >
              <span className="flex items-center gap-1.5 truncate">
                <MapPin size={13} className="text-[#77C712] flex-shrink-0" />
                <span className="text-gray-500 font-normal">Deliver to:</span>
                <span className="font-bold truncate max-w-[180px]">
                  {locationDisplay}
                </span>
              </span>
              <span className="text-[11px] font-bold text-[#77C712] flex-shrink-0">
                Change
              </span>
            </button>
          </div>

          {/* Search Bar with Live Suggestions — Mobile only */}
          <div className="md:hidden pb-2 relative z-40">
            <HeaderSearchBar
              isMobile={true}
              onAfterNavigate={() => setIsMenuOpen(false)}
            />
          </div>

          {/* ── Desktop Navigation ── */}
          <nav className="hidden lg:flex items-center justify-center border-t border-gray-100 pt-2 pb-2">
            <div className="flex items-center gap-6">
              <Link
                to="/"
                className="text-black hover:text-[#77C712] font-medium text-sm transition-colors no-underline"
              >
                HOME
              </Link>
              <Link
                to="/about-us"
                className="text-black hover:text-[#77C712] font-medium text-sm transition-colors no-underline"
              >
                ABOUT US
              </Link>

              {/* Products Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setIsDropdownOpen(true)}
                onMouseLeave={() => setIsDropdownOpen(false)}
              >
                <button
                  className={`font-medium text-sm transition-colors ${
                    isDropdownOpen ? "text-[#77C712]" : "text-black"
                  }`}
                >
                  SHOP ▾
                </button>
                {isDropdownOpen && (
                  <div className="absolute left-0 top-full w-52 bg-white rounded-md shadow-lg border border-gray-100 z-50 py-1">
                    {rootcategorieslist?.map((item) => (
                      <Link
                        key={item?.id}
                        to={`/products?category=${encodeURIComponent(
                          item?.title || ""
                        )}&category_id=${encodeURIComponent(item?.id || "")}`}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-green-50 hover:text-[#77C712] no-underline transition-colors"
                        onClick={() => setIsDropdownOpen(false)}
                      >
                        {item?.title}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                to="/blogs"
                className="text-black hover:text-[#77C712] font-medium text-sm transition-colors no-underline"
              >
                BLOG
              </Link>
              <Link
                to="/contact-us"
                className="text-black hover:text-[#77C712] font-medium text-sm transition-colors no-underline"
              >
                CONTACT US
              </Link>
            </div>
          </nav>
        </div>

        {/* ── Mobile / Tablet Dropdown Menu ── */}
        <div
          className={`lg:hidden bg-white border-t border-gray-100 overflow-hidden transition-all duration-300 ease-in-out ${
            isMenuOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <nav className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className="flex items-center px-3 py-2.5 text-[#77C712] font-semibold text-sm bg-green-50 rounded-md no-underline"
              onClick={() => setIsMenuOpen(false)}
            >
              HOME
            </Link>
            <Link
              to="/about-us"
              className="flex items-center px-3 py-2.5 text-gray-700 hover:text-[#77C712] hover:bg-green-50 font-medium text-sm rounded-md transition-colors no-underline"
              onClick={() => setIsMenuOpen(false)}
            >
              ABOUT US
            </Link>

            {/* Mobile: Category links from API */}
            {rootcategorieslist?.map((item) => (
              <Link
                key={item?.id}
                to={`/products?category=${encodeURIComponent(
                  item?.title || ""
                )}&category_id=${encodeURIComponent(item?.id || "")}`}
                className="flex items-center px-3 py-2.5 text-gray-700 hover:text-[#77C712] hover:bg-green-50 font-medium text-sm rounded-md transition-colors no-underline"
                onClick={() => setIsMenuOpen(false)}
              >
                {item?.title}
              </Link>
            ))}

            <Link
              to="/blogs"
              className="flex items-center px-3 py-2.5 text-gray-700 hover:text-[#77C712] hover:bg-green-50 font-medium text-sm rounded-md transition-colors no-underline"
              onClick={() => setIsMenuOpen(false)}
            >
              BLOG
            </Link>
            <Link
              to="/contact-us"
              className="flex items-center px-3 py-2.5 text-gray-700 hover:text-[#77C712] hover:bg-green-50 font-medium text-sm rounded-md transition-colors no-underline"
              onClick={() => setIsMenuOpen(false)}
            >
              CONTACT US
            </Link>

            <div className="pt-2 flex flex-col gap-2">
              <button
                onClick={() => handleNavigate("profile")}
                className="w-full bg-[#77C712] hover:bg-green-600 text-white font-semibold py-2.5 rounded-md transition-colors text-sm"
              >
                Track Order
              </button>

              {/* Show Login in mobile menu if not logged in */}
              {!isAuthenticated() && (
                <button
                  onClick={() => handleNavigate("login")}
                  className="w-full border border-[#77C712] text-[#77C712] hover:bg-green-50 font-semibold py-2.5 rounded-md transition-colors text-sm"
                >
                  Login
                </button>
              )}
            </div>
          </nav>
        </div>
      </header>
    </>
  );
}
